import { PlaceSearchResult } from "@vahak/core/dist/custom-types/location-search";

import { loadCreationFormFieldsTypes } from "../../posting/helpers/constants";
import { CompactLoadPostingInitialValues } from "./types";
import { getDefaultLoadingTimestamp } from "./types";

function mapTextToPlace(placeId: string, text: string): PlaceSearchResult | undefined {
    if (!placeId?.trim()) {
        return undefined;
    }

    const parts = text
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);

    return {
        place_id: placeId,
        description: text,
        city: parts.length >= 2 ? parts[parts.length - 2] : parts[0],
        state: parts.length >= 1 ? parts[parts.length - 1] : undefined
    };
}

/** Maps legacy load form values (dashboard repost / edit prefill) into compact flow state. */
export function mapLoadFormValuesToCompactInitialValues(
    values: loadCreationFormFieldsTypes,
    loadId?: number
): CompactLoadPostingInitialValues {
    const capacity = values.lorryCapacity ?? values.quantity;

    return {
        source: mapTextToPlace(values.srcPlaceId, values.srcText),
        destination: mapTextToPlace(values.destPlaceId, values.destText),
        lorryType: values.lorryType,
        tonnes: capacity != null && capacity !== undefined ? String(capacity) : "",
        lorryBodyType: values.lorryBodyType,
        lorrySize: values.lorrySize,
        lorryTyres: values.lorryTyres,
        sizeText: values.sizeText,
        loadingTimestamp: getDefaultLoadingTimestamp(),
        expectedAmount: values.expectedAmount,
        advancePaymentPercentage: values.advanceAmount,
        minExpectedPrice: values.minExpectedPrice,
        loadId
    };
}

export function hasCompactRepostPrefill(values?: CompactLoadPostingInitialValues): boolean {
    if (!values) {
        return false;
    }

    return Boolean(
        values.source?.place_id && values.destination?.place_id && values.lorryType && values.expectedAmount != null
    );
}
